import { upper, type JanusCtx } from '../ability/context.js';

/** A destruction retires the removed instances, including their pending effects.
 * Replacement rubble and in-place wall breaches keep their own identities. */
export function cancelDestroyedInventoryStatuses(ctx: JanusCtx, removed: readonly string[]): void {
  if (!removed.length) return;
  const ids = new Set(removed.map(upper));
  ctx.statusesAdded = ctx.statusesAdded.filter(status => !ids.has(upper(status.target)));
}

/** Later riders in the same action cannot put an effect back on a retired row. */
export function inventoryDestroyedInFrame(ctx: JanusCtx, targetId: string): boolean {
  return ctx.inventoryChanged.some(change => change.destruction?.frame.remove.some(id => upper(id) === targetId));
}
